// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__aTIlZ","bigColWidth":"Table_bigColWidth__Z-CVJ","biggerColWidth":"Table_biggerColWidth__1vNTr","row":"Table_row__1HbDf","col":"Table_col__3LNLf"};